import "../../style/layout.css"
import SideDRawerNavigation from "./Drawer"
import Navbar from "../Navbar/Navbar"
import { useState, useEffect, useRef, useCallback } from "react"

export function Layout({children}){
    const [isSidebarOPen, setIsSidebarOpen] = useState(false)
    const mainRef = useRef();
    const navRef = useRef();

    function toggleSidebar(){
        if(!isSidebarOPen){
            setIsSidebarOpen(true)
           // setIsSidebarOpen(current => !current)
        }
        else{
            setIsSidebarOpen(false)

        }
    }




      function clickSomewhere(){
        setIsSidebarOpen(false)
      }

      useEffect(() => {
        if(mainRef.current){
            mainRef.current.addEventListener("mousedown", clickSomewhere)
        }
        if(navRef.current){
            navRef.current.addEventListener("mousedown", clickSomewhere)
        }
      }, []);



    return (
        <div className="layout">
            <div ref={navRef}><Navbar toggleSidebar={toggleSidebar} isSidebarOPen={isSidebarOPen} /></div>
            <div className="mainContent ">
                <SideDRawerNavigation isSidebarOPen={isSidebarOPen} clickSomewhere={clickSomewhere} />
                <div className="layoutChildren" 
                    ref={mainRef}
                >
                    {children}
                </div> 
            </div>
        </div>
    )
}


